import { http } from 'services/http';
import { endpoint } from 'services/endpoint';
import { TShopifyAppsApi } from './types';

export const shopifyApps: TShopifyAppsApi = {
	getShopifyApps: (payload) =>
		http.post(endpoint.shopifyApps.SEARCH_APPS, payload).then((response) => response.data),
	getShopifyStores: ({ appId, ...payload }) =>
		http.post(endpoint.shopifyApps.SEARCH_STORES(appId), payload).then((response) => response.data),
	addShopifyApp: (payload) =>
		http.post(endpoint.shopifyApps.ADD_APP, payload).then((response) => response.data),
	installShopifyStore: ({ appId, ...payload }) =>
		http.post(endpoint.shopifyApps.INSTALL_STORE(appId), payload).then((response) => response.data),
};
